<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M15.9998 29.3337C23.3636 29.3337 29.3332 23.3641 29.3332 16.0003C29.3332 8.63653 23.3636 2.66699 15.9998 2.66699C8.63604 2.66699 2.6665 8.63653 2.6665 16.0003C2.6665 23.3641 8.63604 29.3337 15.9998 29.3337Z"
    />
    <path d="M6.57333 6.57333L12.2267 12.2267" />
    <path d="M19.7733 12.2267L25.4267 6.57333" />
    <path d="M19.7733 19.7733L25.4267 25.4267" />
    <path d="M12.2267 19.7733L6.57333 25.4267" />
    <path
      d="M15.9998 21.3337C18.9454 21.3337 21.3332 18.9458 21.3332 16.0003C21.3332 13.0548 18.9454 10.667 15.9998 10.667C13.0543 10.667 10.6665 13.0548 10.6665 16.0003C10.6665 18.9458 13.0543 21.3337 15.9998 21.3337Z"
    />
  </svg>
</template>
